module.exports = __webpack_public_path__ + "img/paperboi-goodie.e252fe4.jpg";